// extracted by mini-css-extract-plugin
var _1 = "FileInput-modulefileListItem__zIQ7k FileList-modulefileListItem__AWC2n";
var _2 = "FileInput-moduleuploadPlaceholder__KV_f2 FileUploadPlaceholder-moduleFileUploadPlaceholder__LRagJ";
export { _1 as "fileListItem", _2 as "uploadPlaceholder" }
